// import { Accessory } from '../accessory.class';
// import { accessoryAssets } from '../data/accessory-assets.class';
import { Accessories } from '../accessories.class';
import { AccessoriesItemData } from '../data/accessory-assets.class';
import { Accessory } from '../accessory.class';

export const addSkuCfn = (accessories: Accessories, sku: string): Accessory => {
	const skuAsset = AccessoriesItemData.findBySku(sku) ?? null;
	if (skuAsset === null) return null;

	const accessory = new Accessory({ dataIn: { sku }, parent: accessories });

	// can this be added, are the island sku's required in the promotional sku requirements
	if (accessory.pairedAppliance) {
		// TODO: use kitchen msrpItemized to get the sku's for comparison
	}

	return accessory;
};
